export const FnUiDatetimePickerData = {
  DATE_TIME: '',
  maxDate: '',
  minDate: '',
};
